<mat-form-field lvrInput [lvrError]="hasError() && !isOpen()">
	<input
		#searchInput
		matInput
		type="text"
		autocomplete="off"
		[placeholder]="searchPlaceholder() || placeholder()"
		[disabled]="disabled()"
		[attr.aria-label]="ariaLabel() || placeholder() || null"
		[attr.aria-required]="required() ? 'true' : null"
		[value]="searchTerm()"
		(input)="onSearch($event)"
		(focus)="openPanel()"
		(click)="openPanel()"
		(blur)="onBlur()"
		[matAutocomplete]="autocomplete"
	/>
	@if (filterText() || selectedOption()) {
		<button
			mat-icon-button
			matSuffix
			type="button"
			[attr.aria-label]="clearAriaLabel()"
			(mousedown)="$event.preventDefault()"
			(click)="$event.stopPropagation(); clear(searchInput)"
		>
			<mat-icon aria-hidden="true">close</mat-icon>
		</button>
	}

	<mat-autocomplete
		#autocomplete="matAutocomplete"
		[displayWith]="displayValueForValue.bind(this)"
		(optionSelected)="onOptionSelected($event.option.value, searchInput, $event.option)"
		(opened)="onAutocompleteOpened()"
		(closed)="onPanelClosed()"
	>
		@for (option of filteredOptions(); track optionValue()(option); let i = $index) {
			<mat-option [value]="optionValue()(option)">
				@if (optionTemplate()) {
					<ng-container
						*ngTemplateOutlet="
							optionTemplate();
							context: {
								$implicit: option,
								option: option,
								index: i,
								selected: optionValue()(option) === value(),
							}
						"
					></ng-container>
				} @else {
					{{ optionLabel()(option) }}
				}
			</mat-option>
		} @empty {
			<mat-option disabled>{{ noResultsText() }}</mat-option>
		}
	</mat-autocomplete>

	@if (!hasError() && hintText()) {
		<mat-hint>{{ hintText() }}</mat-hint>
	}

	@if (hasError() && !isOpen() && errorMessage()) {
		<mat-error>{{ errorMessage() }}</mat-error>
	}
</mat-form-field>
